import { t } from "i18next";
import { cn } from "@/lib/utils";
import { OpeningHoursInfo, isOpen } from "@/lib/openingHours";

import useMapStore from "@/store/mapStore";

function PoiDetailsHeading({ showMore }: { showMore: boolean }) {
  const currentLanguage = useMapStore((state) => state.currentLang);
  let poi = useMapStore((state) => state.routeFinish);
  const haveRouteDetails = useMapStore((state) => state.haveRouteDetails);
  const navMode = useMapStore((state) => state.navMode);
  const cityFinish = useMapStore((state) => state.cityFinish);
  const activeStop = useMapStore((state) => state.activeStop);
  const stops = useMapStore((state) => state.stops);

  if (stops.length > 2 && stops[activeStop]?.feature) {
    poi = stops[activeStop].feature!;
  }

  const getOpenHours = () => {
    const d = new Date();
    const weekDay = d.getDay();

    if (poi.properties) {
      if (
        poi.properties.workingHours &&
        poi.properties.workingHours[weekDay] &&
        poi.properties.workingHours[weekDay].length > 0
      ) {
        const openHours = `${poi.properties.workingHours[weekDay][0]} - ${poi.properties.workingHours[weekDay][1]}`;
        return isOpen(openHours);
      } else if (
        poi.properties.metadata &&
        poi.properties.metadata.openHours &&
        poi.properties.metadata.openHours[weekDay].en &&
        poi.properties.metadata.openHours[weekDay].en.length > 0
      ) {
        const openHours = poi.properties.metadata.openHours[weekDay][
          currentLanguage
        ]
          ? poi.properties.metadata.openHours[weekDay][currentLanguage]
          : poi.properties.metadata.openHours[weekDay].en;
        return isOpen(openHours);
      } else {
        return "";
      }
    }
    return "";
  };

  const isVacant = () => {
    return (
      poi.properties?.amenity ===
      "b5fe8767-8a52-4635-94d0-d9df03702e7b:b4c9edea-8027-4615-b881-498ec4262aee"
    );
  };

  if (navMode !== "mall" && !cityFinish.poiId) {
    return (
      <>
        <div className="flex items-center gap-8 lg:mb-2">
          <h1 className="flex-1 text-xl font-bold lg:text-2xl">
            {cityFinish.title}
          </h1>
        </div>
      </>
    );
  }

  return (
    <>
      <div className="flex items-center gap-8 lg:mb-2">
        <h1 className="flex-1 text-xl font-bold lg:text-2xl">
          {poi.properties?.title}
        </h1>
        <h3
          className={cn(
            "font-semibold",
            haveRouteDetails && "-mb-[70px] lg:mb-0",
          )}
        >
          {t("floor")}:{" "}
          {poi.properties?._dynamic?.floorName
            ? poi.properties?._dynamic.floorName
            : poi.properties?.level}
        </h3>
      </div>
      {!isVacant() && (
        <h3
          className={cn(
            "lg:block",
            !showMore && "hidden",
            haveRouteDetails && "lg:hidden",
          )}
        >
          {typeof getOpenHours() === "string" && (getOpenHours() as string)}
          {typeof getOpenHours() !== "string" && (
            <>
              {(getOpenHours() as OpeningHoursInfo).isOpen ? (
                <span className="text-lime-500">{t("open")} </span>
              ) : (
                <span className="text-rose-600">{t("closed")} </span>
              )}
              {(getOpenHours() as OpeningHoursInfo).openingHours}
            </>
          )}
        </h3>
      )}
    </>
  );
}

export default PoiDetailsHeading;
